<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>棋盘修正</span>
          <el-form>
            <el-form-item label="体力反比开关">
              <el-switch
                v-model="spinsReturnStatus"
                active-text="开启"
                inactive-text="关闭"
                @change="spinsReturnStatusChange"
              />
            </el-form-item>
          </el-form>
          <CommonExport :import-p="'config:slotWeightChangeCfg:import'" :export-p="'config:slotWeightChangeCfg:export'" :get-table="getTables" :import-method="importSlotWeightChangeCfg" :export-method="exportSlotWeightChangeCfg" />
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            v-for="(item, index) in tableHeader"
            :key="index"
            :label="String(item)"
          >
            <template v-slot:default="scope">
              {{ scope.row[index] }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import CommonExport from '@/components/CommonExport/index.vue'
import {
  changeSpinsReturnStatus,
  exportSlotWeightChangeCfg,
  getSlotWeightChangeCfg, getSpinsReturnStatus, importSlotWeightChangeCfg
} from '@/api/config/slot'
import { getToken } from '@/utils/auth'

export default {
  name: 'Index',
  components: {
    CommonExport
  },
  data() {
    return {
      spinsReturnStatus: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      tableHeader: ['累计消耗体力', 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      tableData: [],
      tableData2: []
    }
  },
  created() {
    this.getTables()
    this.getSpinsReturn()
  },
  methods: {
    exportSlotWeightChangeCfg,
    importSlotWeightChangeCfg,
    getTables(name = 'checkerboardAmendment') {
      this.tableHeader = []
      this.tableData = []
      getSlotWeightChangeCfg({ name: name }).then(res => {
        if (res.code === 200) {
          this.tableHeader = res.data.header2
          this.tableHeader.unshift('累计消耗体力')
          this.tableData2 = res.data.header1
          for (const i in res.data.data) {
            const val = res.data.data[i]
            const data = [i]
            for (const k in val) {
              data.push(val[k])
            }
            this.tableData.push(data)
          }

          // console.log('this.tableData', this.tableData)
          // this.tableData = res.data.data
        }
      })
    },
    importProbUploadSuccess(response, name) {
      importSlotWeightChangeCfg({ data: response.data.path, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(name) {
      exportSlotWeightChangeCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getSpinsReturn() {
      getSpinsReturnStatus().then(res => {
        if (res.code === 200) {
          this.spinsReturnStatus = !!res.data
        }
      })
    },
    spinsReturnStatusChange(status) {
      const s = status ? 1 : 0
      changeSpinsReturnStatus({ type: s }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getSpinsReturn()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
